import { FileIdDto } from '@app/core/api/file';
import { LinkPreviewDto } from '@app/core/api/news';

export interface NewsCommentCreateRequestDto {
  text: string;
  parentCommentId?: string | null;
  attachments: FileIdDto[];
  links?: LinkPreviewDto[];
}
